import * as React from "react";
import "../filters.scss";
import RadioButton, {IRadioButton} from "../../../../hiberUiKit/src/atoms/Buttons/RadioButton";
import WithinTheLastFilter, {WithinTheLastFilterModel} from "./WithinTheLastFilter";
import BetweenFilter, {BetweenFilterModel} from "./BetweenFilter";
import InRangeFilter, {InRangeFilterModel} from "./InRangeFilter";
import {none, option, Option} from "ts-option";
import DateFilterModel from "../../../../model/workspace/DateFilterModel";
import FilterButton from "../button/FilterButton";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import FilterButtons from "../FilterButtons";
import Filter from "../../../../model/workspace/Filter";
import {
	CollectionFilterType,
	CollectionFilterTypeName,
	default as CollectionFilterModel
} from "../../../../model/workspace/CollectionFilterModel";
import MoreThanAgoFilter, {MoreThanAgoFilterModel} from "./MoreThanAgoFilter";
import {SelectableOption} from "../../../../hiberUiKit/src/molecules/OptionSelector/OptionSelector";
import UpToFilter, {UpToFilterModel} from "./UpToFilter";
import MoreThanFromNowFilter, {MoreThanFromNowFilterModel} from "./MoreThanFromNowFilter";
import deepEqual = require("deep-equal");

interface IProps {
	filter: Filter;
	onRemove: (refreshData: boolean) => void;
	onChange: (filter: Filter) => void;
	isFilterConfigVisible?: boolean;
	isCollection?: boolean
}

interface IState {
	/**
	 * Selected radio button Id
	 */
	selectedRadioButtonId: DateFilterType | CollectionFilterType
	/**
	 * Errors
	 */
	error: string;

	value: Option<DateFilterModel | CollectionFilterModel>

	isFilterConfigVisible: boolean
}

export default class DateFilter extends React.Component<IProps, IState> {
	allRadioButton: IRadioButton;
	notSetRadioButton: IRadioButton;

	constructor(props: IProps) {
		super(props);
		this.state = {
			selectedRadioButtonId: props.filter.values.map(v => (v as FilterModelType).radioButtonId).orNull,
			error: "",
			isFilterConfigVisible: props.isFilterConfigVisible,
			value: none
		};

		if (props.isCollection) {
			this.allRadioButton = {
				label: CollectionFilterTypeName[CollectionFilterType.All],
				disabled: false,
				value: CollectionFilterType.All
			};
			this.notSetRadioButton = {
				label: CollectionFilterTypeName[CollectionFilterType.Empty],
				disabled: false,
				value: CollectionFilterType.Empty
			}
		}
		else {
			this.allRadioButton = {
				label: DateFilterTypeName[DateFilterType.All],
				disabled: false,
				value: DateFilterType.All
			};
			this.notSetRadioButton = {
				label: DateFilterTypeName[DateFilterType.Empty],
				disabled: false,
				value: DateFilterType.Empty
			};
		}


		this.onDateFilterSelect = this.onDateFilterSelect.bind(this);
		this.onDateFilterChange = this.onDateFilterChange.bind(this);
		this.resetFilter = this.resetFilter.bind(this);
		this.onError = this.onError.bind(this);
		this.onCollectionFilterChange = this.onCollectionFilterChange.bind(this);
		this.onDone = this.onDone.bind(this);
		this.onCancel = this.onCancel.bind(this);
	}

	render() {
		const value = this.props.filter.values.orNull;
		const withinLastValue = value instanceof WithinTheLastFilterModel ?
			this.props.filter.values as Option<WithinTheLastFilterModel> :
			none;
		const moreThanAgoValue = value instanceof MoreThanAgoFilterModel ?
			this.props.filter.values as Option<MoreThanAgoFilterModel> :
			none;
		const betweenValue = value instanceof BetweenFilterModel ? this.props.filter.values as Option<BetweenFilterModel> : none;
		const inRangeValue = value instanceof InRangeFilterModel ? this.props.filter.values as Option<InRangeFilterModel> : none;
		const upToValue = value instanceof UpToFilterModel ? this.props.filter.values as Option<UpToFilterModel> : none;
		const moreThanFromNowValue = value instanceof MoreThanFromNowFilterModel ?
			this.props.filter.values as Option<MoreThanFromNowFilterModel> : none;

		return (
			<div>
				<FilterButton filterName={this.props.filter.columnDefinition.label}
							  onRemove={() => this.props.onRemove(true)}
							  onClick={() => this.setState({isFilterConfigVisible: true})}
							  filterValue={this.props.filter.values.map(v => (v as FilterModelType).getDisplayValue()).orNull}
							  isDisabled={this.state.isFilterConfigVisible}
				/>
				{this.state.isFilterConfigVisible &&
				<DropDownWrapper width={"auto"} onOutsideClick={this.onCancel}>
					<div className={"c-filter-dates"}>
						<div className={"c-filter-dates_options-container"}>
							<div className={"c-filter-dates_inputs"}>
								<div className={"c-filter-dates_inputs_row"}>
									<UpToFilter
										value={upToValue}
										onChange={this.onDateFilterChange}
										selectedRadioButtonId={this.state.selectedRadioButtonId}
										onSelectButton={this.onDateFilterSelect}/>
								</div>
								<div className={"c-filter-dates_inputs_row"}>
									<MoreThanFromNowFilter
										value={moreThanFromNowValue}
										onChange={this.onDateFilterChange}
										selectedRadioButtonId={this.state.selectedRadioButtonId}
										onSelectButton={this.onDateFilterSelect}/>
								</div>
								<div className={"c-filter-dates_inputs_row"}>
									<WithinTheLastFilter
										value={withinLastValue}
										onChange={this.onDateFilterChange}
										selectedRadioButtonId={this.state.selectedRadioButtonId}
										onSelectButton={this.onDateFilterSelect}/>
								</div>
								<div className={"c-filter-dates_inputs_row"}>
									<MoreThanAgoFilter
										value={moreThanAgoValue}
										onChange={this.onDateFilterChange}
										selectedRadioButtonId={this.state.selectedRadioButtonId}
										onSelectButton={this.onDateFilterSelect}/>
								</div>
								<div className={"c-filter-dates_inputs_row"}>
									<BetweenFilter value={betweenValue}
												   onChange={this.onDateFilterChange}
												   selectedRadioButtonId={this.state.selectedRadioButtonId}
												   onSelectButton={this.onDateFilterSelect}/>
								</div>
								<div className={"c-filter-dates_inputs_row"}>
									<InRangeFilter
										value={inRangeValue}
										onChange={this.onDateFilterChange}
										selectedRadioButtonId={this.state.selectedRadioButtonId}
										onSelectButton={this.onDateFilterSelect}
										onError={this.onError}/>
								</div>
								<div className={"c-filter-dates_inputs_row_last"}>
									<RadioButton radioButton={this.notSetRadioButton}
												 onChange={this.onCollectionFilterChange}
												 checked={this.state.selectedRadioButtonId === this.notSetRadioButton.value}
												 onFocus={this.resetFilter}/>
									<div className={"c-filter-dates_inputs_row_last_all-radio-button"}>
										<RadioButton radioButton={this.allRadioButton}
													 onChange={this.onCollectionFilterChange}
													 checked={this.state.selectedRadioButtonId === this.allRadioButton.value}
													 onFocus={this.resetFilter}/>
									</div>
								</div>
							</div>
						</div>
						{this.state.error &&
						<div className={"c-filter-dates_error"}>
							{this.state.error}
						</div>}
					</div>
					<FilterButtons onCancel={this.onCancel}
								   onDone={this.onDone}
								   disabled={this.state.value.isEmpty}/>
				</DropDownWrapper>}
			</div>
		)
	}

	/**
	 * Overwrite selected radio button Id in state
	 * @param {string} filtersRadioButtonId
	 */
	onDateFilterSelect(filtersRadioButtonId: DateFilterType) {
		this.setState({selectedRadioButtonId: filtersRadioButtonId, value: none});
	}

	onDateFilterChange(value: Option<FilterModelType>) {
		this.setState({value})
	}

	onCollectionFilterChange(checked: boolean, buttonOption: IRadioButton) {
		if (this.props.isCollection) {
			const value: CollectionFilterType = buttonOption.value as CollectionFilterType;
			this.setState({selectedRadioButtonId: value, value: option(new CollectionFilterModel(value))});
		}
		else {
			const value: DateFilterType = buttonOption.value as DateFilterType;
			this.setState({selectedRadioButtonId: value, value: option(new DateFilterModel(value))});
		}
	}

	onCancel() {
		this.setState({isFilterConfigVisible: false}, () => this.props.filter.values.isEmpty && this.props.onRemove(false));
	}

	onDone() {
		this.setState({isFilterConfigVisible: false},
			() => !this.isEqual(this.props.filter.values as Option<FilterModelType>, this.state.value)
				&&
				this.props.onChange(this.props.filter.copy({values: this.state.value, type: this.state.selectedRadioButtonId})))
	}

	isEqual(value1: Option<FilterModelType>, value2: Option<FilterModelType>): boolean {

		return value1.map(
			v1 => value2.map(v2 => v1.radioButtonId == v2.radioButtonId && deepEqual(v1.toQueryJson(), v2.toQueryJson()))
				.getOrElse(false)).getOrElse(value2.isEmpty);
	}

	/**
	 * On error
	 * @param {string} error
	 */
	onError(error: string) {
		this.setState({error: error});
	}

	/**
	 * Reset filter
	 */
	resetFilter() {
		this.setState({
			error: ""
		})
	}
}

export type FilterModelType =
	DateFilterModel
	| CollectionFilterModel
	| BetweenFilterModel
	| MoreThanAgoFilterModel
	| WithinTheLastFilterModel
	| InRangeFilterModel
	| UpToFilterModel
	| MoreThanFromNowFilterModel

export enum DateFilterType {
	WithinTheLast = "WITHIN_THE_LAST",
	MoreThanAgo = "MORE_THAN_AGO",
	InRange = "IN_RANGE",
	Between = "BETWEEN",
	All = "IS_NOT_NULL",
	Empty = "IS_NULL",
	UpTo = "UP_TO",
	MoreThanFromNow = "MORE_THAN_FROM_NOW"
}

export const DateFilterTypeName = {
	[DateFilterType.WithinTheLast]: "Within the last",
	[DateFilterType.MoreThanAgo]: "More than",
	[DateFilterType.InRange]: "In Range",
	[DateFilterType.Between]: "Between",
	[DateFilterType.All]: "All",
	[DateFilterType.Empty]: "Not set",
	[DateFilterType.UpTo]: "Up to",
	[DateFilterType.MoreThanFromNow]: "More than"
};

export const unitsOfTime: SelectableOption[] = [
	{value: "minutes"},
	{value: "hours"},
	{value: "days"},
	{value: "weeks"},
	{value: "months"},
	{value: "quarters"},
	{value: "years"},
];